import { migrationContext } from '../../migrationUsersBranchView.poeditor';

export const migrationInfoKeys = {
  title: `${migrationContext}-mbMigrationStepsTitle`,
  description: `${migrationContext}-mbMigrationStepsDescription`,
  step1Title: `${migrationContext}-mbMigrationStepsSignTermsAndConditions`,
  step2Title: `${migrationContext}-mbMigrationStepsVideocallIdentification`,
  step2Description: `${migrationContext}-mbMigrationStepsGermanRegulation`,
  messageTitle: `${migrationContext}-mbMessageImportantInformationTitle`,
  messageDescription: `${migrationContext}-mbMessageImportantInformationDescriptionInvestmentWillBeBlocked`,
  continueDescription1: `${migrationContext}-mbMigrationContinueProcessDescriptionInformationAccepted1`,
  dataProtectionLink: `${migrationContext}-mbMigrationContinueProcessDescriptionInformationAcceptedLink`,
  continueDescription2: `${migrationContext}-mbMigrationContinueProcessDescriptionInformationAccepted2`,
  cancelMigrationLink: `${migrationContext}-mbMigrationIDoNotWantToMigrateToTheNewBankLink`,
  readyLink: `${migrationContext}-mbMigrationPdfViewerHybridReadyLink`,
};
